'use strict'

const getMeta = require('../../../functions/getMeta')
const { createYConnection } = require('../../../functions/createYConnection')

module.exports = [
    function () {

        return {
            templateUrl: '/partial/app.partials.rundown.directives.header',
            replace: true,
            controller: ['$scope', '$rootScope', '$http', '$state', '$mdDialog', 'userSettings', 'UserFilters', rmRundownHeaderCtrl],
            controllerAs: 'ctrl',
            scope: {
                rundownInfo: '='
            },
            link: function (scope, element, attributes, controllers) {
            },
        }
    },
]

class rmRundownHeaderCtrl {
    constructor ($scope, $rootScope, $http, $state, $mdDialog, userSettings, UserFilters) {
        let availableBroadcasts = []
        this.$scope = $scope
        this.$rootScope = $rootScope
        this.$http = $http
        this.$state = $state
        this.$mdDialog = $mdDialog
        this.broadcastCalendar = {}
        this.userSettings = userSettings
        this.rundownInfo = this.$scope.rundownInfo
        this.saveBroadCastData = []
        this.no_previousBroadcast = true
        this.no_nextBroadcast = true

        if (!this.rundownInfo.broadcast) {
            this.didNotFound()
            return this
        }
        this.broadcastCheckButtonToActive()

        this.dateFilterUpdate = {}
        this.cachedMonths = []
        this.UserFilters = UserFilters
        this.userId = window.CONFIG.user_id

        this.stationId = this.rundownInfo.masterstation_id || window.CONFIG.station_id

        this.filterMap = []
        this.UserFilters.get((data) => {
            this.filterMap = data.userFilters
        })

        this.getPrintFilters()
        $scope.$on('active_station_filters_update', (event, filters) => this.filterMap[this.stationId] = filters)
        $scope.$watch('rundownInfo', () => {
            this.broadcastCalendar.current = this.$scope.rundownInfo.broadcast ? new Date(this.$scope.rundownInfo.broadcast.start) : new Date()
        })
        //Broadcast Picker callback functions
        this.availableBroadcastDates = (monthBodyCtrl) => {
            let date = monthBodyCtrl.dateUtil.incrementMonths(monthBodyCtrl.calendarCtrl.firstRenderableDate, monthBodyCtrl.offset)
            let httpDate = new Date(date)
            let year = httpDate.getFullYear()
            let month = parseInt(httpDate.getMonth(), 10)
            if (this.cachedMonths.indexOf(year + '' + month) == -1) {

                let url
                if (this.rundownInfo.masterstation_id) {
                    url = 'broadcasts/masterrelated/' + this.rundownInfo.masterstation_id + '/' + this.rundownInfo.broadcast.program_id + '/' + year + '/' + month
                } else {
                    url = 'broadcasts/related/' + this.rundownInfo.broadcast.program_id + '/' + year + '/' + month
                }

                this.$http.get(url).then((req) => {
                    let broadcasts = req.data
                    this.cachedMonths.push(year + '' + month)
                    if (broadcasts.length > 0) {
                        broadcasts.forEach((broadcast, index) => {
                            availableBroadcasts[moment(broadcast.start).format('YYYY-MM-DD')] = broadcast
                            if (index == broadcasts.length - 1) {
                                this.dateFilterUpdate.generateContent(monthBodyCtrl)
                            }
                        })
                    } else {
                        this.dateFilterUpdate.generateContent(monthBodyCtrl)
                    }
                })
            }
        }
        this.checkWhichDateIsAvailable = (date) => {
            return availableBroadcasts[moment(date).format('YYYY-MM-DD')] ? true : false
        }

        this.onCalendarChange = (date) => {
            let current_broadcast = this.rundownInfo.broadcast
            let postData =
                {
                    start: moment(date).startOf('day').toISOString(),
                    stop: moment(date).endOf('day').toISOString(),
                    program_id: current_broadcast.program_id
                }

            let broadcast = availableBroadcasts[moment(date).format('YYYY-MM-DD')]
            this.executeChangeBroadcast(postData, broadcast)
        }

        userSettings.addListener((settings) => {
            for (let setting in settings) {
                if (settings.hasOwnProperty(setting)) {
                    this[setting] = settings[setting]
                }
            }
        })

        this.chatUsers = {}
        this.chatUsersCount = 0
        this.unreadMessages = 0

        $rootScope.$on('rm_chat_liveUserAdd', (event, roomName, userId, userData) => {
            // if (parseInt(userId, 10) === window.CONFIG.user_id) return;
            this.chatUsers[userId] = userData
            this.chatUsersCount++
        })

        $rootScope.$on('rm_chat_liveUserDelete', (event, roomName, userId) => {
            // if (parseInt(userId, 10) === window.CONFIG.user_id) return;
            delete this.chatUsers[userId]
            this.chatUsersCount--
        })

        $rootScope.$on('rm_chat_newMessage', (event, roomName) => {
            if (!this.chatSideBarOpen) {
                this.unreadMessages++
            }
        })
    }

    didNotFound () {
        const { rundownInfo, $mdDialog } = this
        rundownInfo.notFound = true
        $mdDialog.show({
            templateUrl: '/partial/app.partials.rundown.rundown_not_found',
            parent: angular.element(document.querySelector('#popupContainer')),
            clickOutsideToClose: true,
            multiple: true,
            controller: ($scope, $mdDialog) => {
                $scope.fromMasterStation = 'masterstation_id' in rundownInfo
                $scope.closeNotFoundDialog = function () {
                    $mdDialog.hide()
                }
            }
        })
    };

    getYjsRoomName () {

        const {
            stationId,
            $scope: {
                type,
                typeId,
            },
        } = this

        return `chat.${stationId}.${type}.${typeId}`
    }

    openMenu ($mdMenu, ev) {
        $mdMenu.open(ev)
    }

    toggleViewParts (type) {
        this[type] = !this[type] || false
        this.userSettings.setSetting(type, this[type])
    }

    toggleChatScreen () {
        this.chatSideBarOpen = !this.chatSideBarOpen
        if (this.chatSideBarOpen) {
            this.unreadMessages = 0
        }
        this.$rootScope.$broadcast('rundown_toggle_side_container')
    }

    toggleFullscreen () {
        if (this.$rootScope.hugeRundown) {
            let exitMethod = document.exitFullscreen || document.webkitExitFullscreen || document.mozCancelFullScreen || document.msExitFullscreen
            exitMethod.call(document)
        } else {
            let element = $('html')[0]
            let requestMethod = element.requestFullScreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || element.msRequestFullScreen
            requestMethod.call(element)
        }
        this.$rootScope.hugeRundown = !this.$rootScope.hugeRundown
        this.$scope.fullscreen = this.$rootScope.hugeRundown
    }

    focusPlaying () {
        this.$rootScope.$broadcast('focusPlaying')
    }

    printPage (template_id) {
        //Open the printpage in a new tab using an anchor with rel='noopener'
        //Else the new tab will use the same renderer as the original page and window.print() will freeze the rundown
        //This seems to be the only workaround for this, source:
        //https://bugs.chromium.org/p/chromium/issues/detail?id=178931

        const body = document.body
        const anchor = document.createElement('a')

        anchor.href = `print/templatebroadcast_rundown/${this.rundownInfo.broadcast.id}/${template_id}?_token=${getMeta('csrf-token')}`
        anchor.target = '_blank'
        anchor.rel = 'noopener'
        body.appendChild(anchor)
        anchor.click()
        body.removeChild(anchor)
    }

    getPrintFilters () {
        let filters = []
        let stationId = this.stationId
        if (this.filterMap[stationId]) {
            this.filterMap[stationId].map((filter) => {

                if (filter.enabled) {
                    filters.push(filter.id)
                }
            })
        }

        return filters.toString()
    }

    broadcastCheckButtonToActive () {
        const { $http, rundownInfo, $scope } = this
        $http.get(`broadcasts/related/closest/${rundownInfo.broadcast.id}/${rundownInfo.broadcast.program_id}`)
            .then(({ data: responseData }) => {
                $scope.$applyAsync(() => {
                    this.saveBroadCastData = responseData
                    if (responseData.previous != null) {
                        this.no_previousBroadcast = false
                    }
                    if (responseData.next != null) {
                        this.no_nextBroadcast = false
                    }
                })
            })
    }

    previousBroadcast () {
        this.changeBroadcast(this.saveBroadCastData.previous)
    }

    nextBroadcast () {
        this.changeBroadcast(this.saveBroadCastData.next)
    }

    // The arrows already know their exact neighbour, so don't go through the date picker's
    // rundowncalender lookup: its window also catches a broadcast starting as this one stops,
    // and the picker then hides both if this one crosses midnight (RM-157).
    changeBroadcast (data) {
        this.$state.go('rundown', {
            program: this.rundownInfo.broadcast.program_id,
            broadcast: data.id
        })
    }

    executeChangeBroadcast (postData, broadcast) {
        this.$http.post('/broadcasts/rundowncalender', postData).then((response) => {
            if (response.data.length > 1) {
                this.$mdDialog.show({
                    templateUrl: 'selectBroadcast.ngTemplate',
                    scope: this.$scope,
                    preserveScope: true,
                    parent: angular.element(document.querySelector('#popupContainer')),
                    locals: {
                        broadcasts: response.data,
                        target_date: moment(postData.start)
                    },
                    clickOutsideToClose: true,
                    controller: 'SelectBroadcastCtrl',
                    multiple: true
                })
            } else {
                this.$state.go('rundown', {
                    program: this.rundownInfo.broadcast.program_id,
                    broadcast: broadcast.id
                })
            }
        }, () => {
            //go to first broadcast on date if query fails
            this.$state.go('rundown', {
                program: this.rundownInfo.broadcast.program_id,
                broadcast: broadcast.id
            })
        })
    }

}
